import { ReactNode, useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

export default function AuthGuard({ children }: { children: ReactNode }) {
  const { initialized, getToken, user } = useAuth();
  const [tokenReady, setTokenReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    async function ensureToken() {
      if (!initialized || !user) return;
      const token = await getToken();
      if (mounted) setTokenReady(!!token);
    }
    ensureToken();
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialized, getToken, user?.id]);

  if (!initialized || !user || !tokenReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-pink-600 mx-auto mb-3" />
          <p className="text-sm text-gray-600">Preparing your session…</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

